import { badgeType } from "types/allTypes";

interface props {
  data: badgeType;
  typeFilter: string;
  filterClickHandler: (data: badgeType) => void;
}

const EachFilter: React.FC<props> = ({ data, typeFilter, filterClickHandler }) => {
  const isActive = typeFilter === data.name;
  const clickHandler = () => {
    filterClickHandler(data);
  };
  return (
    <button
      onClick={clickHandler}
      className={`whitespace-nowrap rounded-full border px-4 py-2 text-sm font-medium duration-300 select-none cursor-pointer ${
        isActive
          ? "bg-primary-50 border-primary-50 text-white shadow-[0_0_20px_rgba(126,92,255,0.4)]"
          : "bg-white/[0.03] border-white/10 text-zinc-400 hover:text-white hover:border-white/25"
      }`}
    >
      {data.name}
    </button>
  );
};

export default EachFilter;
